import { Link, usePage } from '@inertiajs/react'
import type { ReactNode } from 'react'
import type { PageProps } from './types'
import { FlashMessages } from './FlashMessages'

export default function MarketingLayout({ children }: { children: ReactNode }) {
  const { auth, flash } = usePage<PageProps>().props

  return (
    <>
      <nav className="bg-background">
        <div className="mx-auto flex max-w-5xl items-center gap-6 px-4 py-3">
          <Link href="/" className="flex items-center gap-2 text-sm font-semibold text-foreground">
            FindMedStaff.ai
          </Link>

          <div className="flex-1" />

          {auth.user ? (
            <Link
              href="/search"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Dashboard
            </Link>
          ) : (
            <Link
              href="/login"
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Sign In
            </Link>
          )}
        </div>
      </nav>

      <FlashMessages flash={flash} />

      <main className="mx-auto max-w-5xl px-4 py-8">
        {children}
      </main>
    </>
  )
}
